export default function MySQL_ANYALL() {
  return (
    <div>
      <h2>MySQL_ANYALL</h2>    </div>
  );
}